// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    CUSTOM_PAGE_LOADING() {
      return {
        isLoading: true
      };
    },
    CUSTOM_PAGE_LOADED() {
      return {
        isLoading: false,
        data: action.customPage
      };
    },
    CUSTOM_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.customPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
